import styled from 'styled-components';

import LoadingPage from '../../../../../../components/LoadingPage';
import { LinkButton } from '../../../../../../components/Button';
import colors from '../../../../../../styles/colors';

const StyledLoadingPage = styled(LoadingPage)`
  height: 200px;
`;

const RestrictionSettingsContainer = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  align-items: center;
`;

const RestrictionTagContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
  width: 80%;
`;

const SaveRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;

const RefreshLink = styled(LinkButton)`
  && {
    font-size: 13px;
    color: ${colors.shades.gamma2};
    text-decoration: underline dotted;
    padding: 0;
    cursor: pointer;
    &:disabled {
      background: transparent;
    }
  }
`;

export {
  StyledLoadingPage,
  RestrictionSettingsContainer,
  RestrictionTagContainer,
  SaveRow,
  RefreshLink,
};
